import styled from "styled-components";

/**
 * Seção Principal
 * Configura o layout, cor de fundo e padding da seção.
 */
export const StyledSection = styled.section.withConfig({
  shouldForwardProp: (prop) => !["backgroundColor", "isVisible"].includes(prop),
})<{
  backgroundColor: string;
  isVisible: boolean;
}>`
  display: ${({ isVisible }) => (isVisible ? "block" : "none")};
  background: ${({ theme, backgroundColor }) =>
    theme.colors[backgroundColor] || backgroundColor};
  padding: ${({ theme }) => `${theme.spacing(12)} ${theme.spacing(4)}`};
  box-sizing: border-box;
  width: 100%;

  isolation: isolate;
`;

/**
 * Conteúdo da Seção
 * Centraliza e limita a largura máxima do conteúdo interno.
 */
export const StyledContentSection = styled.div.withConfig({
  shouldForwardProp: (prop) => !["maxWidth"].includes(prop),
})<{
  maxWidth: number;
}>`
  max-width: ${({ maxWidth }) => `${maxWidth}px`};
  margin: 0 auto;
  width: 100%;

  /* Garante que elementos filhos como o HeaderFilterMobile possam ocupar 100vw */
  position: relative;
`;
